<template>
 <a :data-dusk="dataDuskSelector" @click.prevent="onPolicyNumberClick" ref="self">
   {{ cellProps }}
 </a>
</template>

<script>
import { mapState}  from "vuex";

export default {
  name: "ContractNumber",
  props: {
    cellProps: {
      type: String,
      required: false,
    },
    row: {
      type: Object,
      required: false,
    }
  },
  methods: {
    onPolicyNumberClick() {
      this.navigator.navigatePath(this.targetRoute)
    }
  },
  computed: {
    dataDuskSelector() {
      return `policy-link-${this.row?.id}`
    },
    ...mapState(`$_policy_page`, {
      activeCustomerId: 'activeCustomerId',
    }),
    targetRoute() {
      return this.route('vue.insurance.policy', {
        customer: this.row?.customer?.data?.id || this.activeCustomerId,
        policy: this.row?.id
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
